/** @jsx jsx */
import { jsx, Box } from 'theme-ui'

import * as styles from './styles'
import { Menu } from '../Icons'

export const Header = props => {
    const { onOpen } = props

    return (
        <div sx={styles.wrapper} data-testid="header">
            <Box sx={styles.menuIcon}>
                <button sx={styles.menuButton} onClick={onOpen}>
                    <Menu size={25} />
                </button>
            </Box>
        </div>
    )
}